export const marketingSchoolDataAfrica = {
  tag: "Marketing",
  id: "marketingSchool",
  url: "/marketing-school",

  name: "Marketing School",
  description: `
  The Digital Marketing learning program is designed for professionals looking to develop and improve
  their skills with the latest digital techniques needed to thrive in the technology industry.
`,

  courses: [],

  testimony: {
    testimonierImage: "",
    testimonierName: "",
    testimonierTitle: "",
    testimonyDescription: ``,
  },

  article: [],
};
